import adobe from './adobeAnalyticSlice'
import { apiSlice } from './apiSlice'
import authentication from './authenticationSlice'
import breadcrumb from './breadcrumbSlice'
import cart from './cartSlice'
import category from './categorySlice'
import config from './configSlice'
import contact from './contactSlice'
import customer from './customerSlice'
import employee from './employeeSlice'
import machine from './machineSlice'
import menu from './menuSlice'
import orders from './orderSlice'
import portfolio from './portfolioSlice'
import productComparison from './productComparisonSlice'
import product from './productSlice'
import promotion from './promotionSlice'
import rental from './rentalSlice'
import right from './rightSlice'
import role from './roleSlice'
import sapLog from './SAPLogSlice'
import search from './searchSlice'
import serviceCase from './serviceCaseSlice'
import setup from './setupSlice'
import supportArea from './supportAreaSlice'
import technical from './technicalSlice'
import user from './userSlice'
import usersManagement from './usersManagementSlice'
import wishlist from './wishlistSlice'

const slices = {
  authentication,
  breadcrumb,
  cart,
  customer,
  orders,
  product,
  contact,
  machine,
  rental,
  category,
  search,
  productComparison,
  serviceCase,
  menu,
  usersManagement,
  promotion,
  sapLog,
  config,
  portfolio,
  employee,
  role,
  right,
  technical,
  user,
  wishlist,
  [apiSlice.reducerPath]: apiSlice.reducer,
  supportArea,
  adobe,
  setup,
}

export default slices
// export default combineSlices(
//   authentication,
//   breadcrumb,
//   cart,
//   customer,
//   orders,
//   product,
//   contact,
//   machine,
//   rental,
//   category,
//   search,
//   productComparison,
//   serviceCase,
//   menu,
//   usersManagement,
//   promotion,
//   sapLog,
//   config,
//   portfolio,
//   employee,
//   role,
//   right,
//   technical,
//   user,
//   wishlist,
//   apiSlice,
//   supportArea,
//   adobe,
//   setup
// );
